import { Time } from "../Helper/Time"

export interface WorkingParticularSetting {
    wrkptc_id: number
    str_id: number
    wrkptc_date: Date
    wrkptc_open?: Time
    wrkptc_close?: Time
}
export interface WorkingParticularSettingProps {
    wrkptc_id: number | string
    str_id: number | string
    wrkptc_date: string
    wrkptc_open?: string | null 
    wrkptc_close?: string | null
}
export const ObjectToWorkingParticularSetting = (obj: WorkingParticularSettingProps): WorkingParticularSetting => {
    return {
        wrkptc_id: typeof obj.wrkptc_id == 'number' ? obj.wrkptc_id : parseInt(obj.wrkptc_id),
        str_id: typeof obj.str_id == 'number' ? obj.str_id : parseInt(obj.str_id),
        wrkptc_date: new Date(obj.wrkptc_date),
        wrkptc_open: obj.wrkptc_open ? new Time(obj.wrkptc_open) : undefined,
        wrkptc_close: obj.wrkptc_close ? new Time(obj.wrkptc_close) : undefined,
    }
}